import { Navigate, useLocation, useSearchParams } from 'react-router-dom'
import KeycloakService from 'services/KeycloakService'

export default function RequireAuth({ children }: { children: JSX.Element }) {
  const [searchParams] = useSearchParams()
  const location = useLocation()

  if (KeycloakService.isLoggedIn()) {
    return children
  }
  const FROM = searchParams.get('from')

  return (
    <Navigate
      to={`/login${FROM ? `?from=${location.search.slice(7)}` : ''}`}
      replace={false}
    />
  )
}
